<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { RouteLocationRaw, useRoute, useRouter } from 'vue-router'

import { useStore } from '@/store'
import { ModeEnum, PmsiTypeEnum } from '@/store/modules/settings/types'

const props = defineProps<{
  currentStayId: number
  mode: ModeEnum
  pmsiType: PmsiTypeEnum
}>()

const router = useRouter()

const store = useStore()
const route = useRoute()
const readingList = computed(() => store.state.stayList.readingList)

onMounted(() => initializeReadingList(props.currentStayId))
async function initializeReadingList(stayId: number) {
  const isReadingList = route.query.readingList === '1'
  if (!isReadingList) {
    return
  }

  await store.dispatch('getCurrentReadingList')

  const readingListStayIds = readingList.value.stayIds
  const stayIdx = readingListStayIds.indexOf(stayId)
  if (stayIdx !== -1) {
    await store.dispatch('navigateReadingList', stayIdx)
  } else {
    await router.replace({
      name: `${props.pmsiType}-stay`,
      params: {
        idType: 'id',
        stayId,
      },
      query: {
        ...route.query,
      }
    })
  }
}

function getReadingListRoute(newIndex: number): RouteLocationRaw {
  const routeQuery = { ...route.query }
  delete routeQuery.stayLabel
  return {
    name: `${props.pmsiType}-stay`,
    params: {
      idType: 'id',
      stayId: readingList.value.stayIds[newIndex],
    },
    query: routeQuery,
  }
}

const endReadingListRoute = computed<RouteLocationRaw>(() => ({
  name: 'home',
  params: { pmsiType: store.getters.pmsiType }
}))

function navigateReadingList(newIndex: number) {
  const readingListStayIds = readingList.value.stayIds
  const stayId = readingListStayIds[newIndex]

  if (stayId) {
    router.push(getReadingListRoute(newIndex))
    store.dispatch('navigateReadingList', newIndex)
  }
}

function endReadingList() {
  store.commit('resetReadingList')
  router.push(endReadingListRoute.value)
}
</script>

<template>
  <div
    v-if="readingList.currentIndex !== null && readingList.stayIds.length"
    class="row g-0 align-items-center"
  >
    <router-link
      v-if="readingList.currentIndex > 0"
      class="col text-end"
      :to="getReadingListRoute(readingList.currentIndex - 1)"
      @click="navigateReadingList(readingList.currentIndex - 1)"
    >
      <div class="btn btn-link">
        &#8592;&nbsp;&nbsp;Précédent
      </div>
    </router-link>
    <div
      v-else
      class="col"
    />

    <div class="col-auto">
      Séjour {{ readingList.currentIndex + 1 }} / {{ readingList.stayIds.length }}
    </div>

    <router-link
      v-if="readingList.currentIndex < readingList.stayIds.length - 1"
      class="col"
      :to="getReadingListRoute(readingList.currentIndex + 1)"
      @click="navigateReadingList(readingList.currentIndex + 1)"
    >
      <div class="btn btn-link">
        Suivant&nbsp;&nbsp;&#8594;
      </div>
    </router-link>
    <router-link
      v-else-if="readingList.currentIndex === readingList.stayIds.length - 1"
      class="col"
      :to="endReadingListRoute"
      @click="endReadingList"
    >
      <div class="btn btn-link">
        Terminer
      </div>
    </router-link>
    <div
      v-else
      class="col"
    />
  </div>
</template>
